// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"5b5fa06c","305":"84492653","863":"5ea4827b"}[chunkId] + ".chunk.js";
};